import { withWebResponsiveDesign } from 'src/hoc/withWebResponsiveDesign';
import { QuantityItemDesktop } from './quantity-item-desktop/QuantityItemDesktop';
import { QuantityItemMobile } from './quantity-item-mobile/QuantityItemMobile';
import { QuantityItemProps } from './QuantityItem.types';
import { Attributes } from 'react';

export const QuantityItem = withWebResponsiveDesign<QuantityItemProps & Attributes>(
  QuantityItemMobile,
  QuantityItemMobile,
  QuantityItemDesktop,
);
